"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a STREAM_SET_TOPIC_SERVICE or STREAM_APPLY_DELTA_SERVICE request.
 */
var UpdateStreamRequest = /** @class */ (function () {
    /**
     * Create a new UpdateStreamRequest instance
     *
     * @param streamId  the id of the update stream
     * @param update  the data to send
     */
    function UpdateStreamRequest(streamId, update) {
        this.streamId = streamId;
        this.update = update;
    }
    return UpdateStreamRequest;
}());
exports.UpdateStreamRequest = UpdateStreamRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/update-stream-request.js
// module id = 237
// module chunks = 1